import React, {useState} from 'react';
import useFeature from "../../useFeature";
import {ProfileFeature} from "./ProfileFeature";
import {observer} from "mobx-react";
import {SalesPoints} from "./screen_sections/SalesPointsSection";
import {Users} from "./screen_sections/UsersSection";
import {PersonalInformation} from "./screen_sections/PersonalInformationSection";

const ProfileScreen = () => {

    const feature = useFeature(() => new ProfileFeature());
    const [activeTab, setActiveTab] = useState('informacionpersonal');

    const isFeatureReady = () => {
        return feature && feature.loaded;
    }

    return (isFeatureReady() &&
        <div className="container">
            <div className="row margintop30">
                <div className="col-xs-12">
                    <p className="general-title">Configuración de cuenta</p>
                </div>
            </div>
            <div className="row margintop10">
                <div className="col-sm-3">
                    <ul className="nav nav-pills nav-stacked">
                        <li className={activeTab === 'informacionpersonal' ? 'active' : ''}>
                            <a data-toggle="tab" href="#informacionpersonal" className="general-title"
                               onClick={() => setActiveTab('informacionpersonal')}>
                                Información Personal
                            </a>
                        </li>
                        {(feature.isAdministrator() || feature.isBranchManager()) && (
                            <>
                                <li className={activeTab === 'usuarios' ? 'active' : ''}>
                                    <a data-toggle="tab" href="#usuarios" className="general-title"
                                       onClick={() => setActiveTab('usuarios')}>
                                        Usuarios
                                    </a>
                                </li>
                                <li className={activeTab === 'puntosdeventa' ? 'active' : ''}>
                                    <a data-toggle="tab" href="#puntosdeventa" className="general-title"
                                       onClick={() => setActiveTab('puntosdeventa')}>
                                        Puntos de venta
                                    </a>
                                </li>
                            </>
                        )}
                        <li>
                            <a data-toggle="tab" href="#informaciondecuenta" className="general-title hide">
                                Información de cuenta
                            </a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#preferenciasdecontacto" className="general-title hide">
                                Preferencias de contacto
                            </a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#contactenos" className="general-title hide">
                                Contáctenos
                            </a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#politicasdeprivacidad" className="general-title hide">
                                Políticas de privacidad
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-9 col-md-8 col-md-offset-1">
                    <div className="tab-content">
                        <div className={`tab-pane fade ${activeTab === 'informacionpersonal' ? 'in active' : ''}`}>
                            <PersonalInformation feature={feature}/>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'usuarios' ? 'in active' : ''}`}>
                            <Users feature={feature}/>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'puntosdeventa' ? 'in active' : ''}`}>
                            <SalesPoints feature={feature}/>
                        </div>
                        <div id="informaciondecuenta" role="tabpanel" className="tab-pane fade">
                            <h3 className="clearmargin">Información De Cuenta</h3>
                        </div>
                        <div id="preferenciasdecontacto" role="tabpanel" className="tab-pane fade">
                            <h3 className="clearmargin">Preferencias de Contacto</h3>
                        </div>
                        <div id="contactenos" role="tabpanel" className="tab-pane fade">
                            <h3 className="clearmargin">Contáctenos</h3>
                        </div>
                        <div id="politicasdeprivacidad" role="tabpanel" className="tab-pane fade">
                            <h3 className="clearmargin">Políticas de privacidad</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(ProfileScreen);
